import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 639px;
  flex-direction: column;
  display: flex;
  align-items: center;
  margin-top: 33px;
`;

const RedBg = styled.div`
  background-color: ${theme.SECONDARY};
  margin-top: -518px;
  width: 100%;
  height: 477px;
  z-index: -1;
`;

const TitleText = styled.div`
  width: 1140px;
  margin-bottom: 40px;
  font-size: 20px;
  font-weight: 500;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: row;
  background-color: black;
  width: 1140px;
  height: 561px;

  .video-title {
    color: ${theme.SECONDARY};
  }
  .upload-date {
    color: white;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    width: 100vw;
  }
`;

const ImageBackground = styled.div`
  ${(props) => props.src && `background-image: url(${props.src})`};
  background-repeat: no-repeat;
`;

const BigVideo = styled.div`
  ${(props) => props.src && `background-image: url(${props.src})`};
  background-repeat: no-repeat;
  height: 433px;
  width: 770px;
  @media (max-width: 1024px) {
    height: 234px;
    width: 416px;
  }
`;

const MainVideo = styled.div`
  height: 433px;
  margin-left: 40px;
  margin-top: -28px;

  .video-title {
    font-size: 24px;
    margin-top: 3px;
    @media (max-width: 1024px) {
      font-size: 20px;
    }
  }

  .upload-date {
    font-size: 16px;
    margin-top: 5px;
    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }

  .bottom-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-side {
      margin-left: 16px;
      margin-top: 10px;
    }

    .like-and-share {
      height: 35px;
      display: flex;
      flex-direction: row;

      @media (max-width: 1024px) {
        margin-top: 10px;
        margin-right: 14px;
      }

      p {
        color: ${theme.SECONDARY};
        font-size: 18px;
        margin: 10px;
      }
    }
  }

  @media (max-width: 1024px) {
    margin-left: 0px;
  }
`;

const SideVideo = styled.div`
  margin-top: 15px;
  margin-bottom: 38px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 252px;
    height: 142px;
  }
  .video-title {
    margin-top: 11px;
    font-size: 18.5px;

    @media (max-width: 1024px) {
      font-size: 18px;
    }
  }
  .upload-date {
    margin-top: 3px;
    font-size: 14px;
    @media (max-width: 1024px) {
      margin-top: 0;
    }
  }

  @media (max-width: 1024px) {
    margin-top: 5px;
    margin-right: 33px;
  }
`;

const CaseStudies = styled.div`
  margin-left: 35px;
  margin-top: 20px;

  .section-title {
    font-size: 24px;
    font-weight: 500;
    color: ${theme.SECONDARY};
    @media (max-width: 1024px) {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    margin-left: 0;
    display: flex;
    flex-direction: row;
    margin-top: 15px;
  }
`;

const VideoBanner = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <TitleText>Our Story</TitleText>
      <ContentArea>
        <MainVideo>
          <BigVideo className="main-video" src={require('assets/images/american-football.png')} />
          <div className="bottom-bar">
            <div className="text-side">
              <p className="video-title">{t('website.watch')}</p>

              <p className="upload-date">{t('website.uploadedDate', { dateText: 'recently' })}</p>
            </div>

            {/*
              <div className='like-and-share'>
                <p> 141 </p>
                <Icon
                  marg='0 21px 0 0'
                  type='like'
                  dimensions='23.83px'
                  col='white'
                />
                <Icon
                  marg='0 5px 0 0'
                  type='share'
                  dimensions='18px'
                  col='white'
                />
              </div>
            */}
          </div>
        </MainVideo>

        <CaseStudies>
          <p className="section-title">{t('website.caseStudies')}</p>

          <SideVideo>
            <ImageBackground
              className="video-thumbnail"
              src={require('assets/images/soccer-player.png')}
            >
              <img src={require('assets/images/play-icon.png')} alt="" />
            </ImageBackground>

            <p className="video-title">{t('Michael Kedman', { dateText: 'recently' })}</p>

            <p className="upload-date">{t('website.uploadedDate', { dateText: 'recently' })}</p>
          </SideVideo>
        </CaseStudies>
      </ContentArea>
      <RedBg />
    </Wrapper>
  );
};

export default VideoBanner;
